module.exports = __webpack_public_path__ + "static/media/express.98ff4822.png";